import { useLang } from '../i18n'

/**
 * Язык интерфейса — в «Настройки → Профиль».
 *
 * Показывается ТОЛЬКО когда в наборе домена больше одного языка: на домене с
 * одним языком выбор был бы обещанием, которого сервис не держит.
 *
 * Переключение мгновенное — каталоги лежат в бандле; профиль догоняет в фоне.
 */
export function LangSetting() {
  const { lang, langs, canSwitch, setLang, t } = useLang()

  if (!canSwitch) return null

  return (
    <div>
      <label className="eyebrow mb-2" htmlFor="cabinet-lang">
        {t('lang.switch')}
      </label>
      <select
        id="cabinet-lang"
        value={lang}
        onChange={e => setLang(e.target.value as typeof lang)}
        className="w-full rounded-lg border border-hull bg-trench px-2.5 py-2 text-sm text-foam focus:border-sonar focus:outline-none"
      >
        {langs.map(code => (
          <option key={code} value={code}>
            {t(`lang.name.${code}`)}
          </option>
        ))}
      </select>
    </div>
  )
}
